import { render } from "./serviceBannerComponent.vue?vue&type=template&id=0a1bd678&scoped=true"
import script from "./serviceBannerComponent.vue?vue&type=script&lang=js"
export * from "./serviceBannerComponent.vue?vue&type=script&lang=js"

import "./serviceBannerComponent.vue?vue&type=style&index=0&id=0a1bd678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1bd678"]])

export default __exports__